module.exports = __webpack_public_path__ + "media/images/icon-notices-disabled-1bada0384586c7dc8651668c6dce0457.svg";